import React from 'react'
import { Field, reduxForm } from 'redux-form'

import QRCode from 'qrcode.react'
import Button from '../../Shared/Button'
import Modal from '../../Shared/Modal'
import { IconButton } from '../../Shared/Icon'
import TwoFactorAuthenticationForm from './TwoFactorAuthenticationForm'
import SettingsModalField from '../../Shared/Forms/SettingsModalField'

const TwoFactorAuthentication = ({
  handleOTPSetup,
  handleOTPDisable,
  otpAuthUrl,
  otpSecret,
  showOtpModal,
  closeModal,
  handleOTPVerify,
  user,
  showConfirmPassowordToDisable2FA,
  toggleShowConfirmPassowordToDisable2FA,
}) => {
  return (
    <>
      <div className="settings-content-box settings-2fa-box">
        {!showConfirmPassowordToDisable2FA && (
          <Button
            small
            outlined
            teal
            onClick={
              user.otpEnabled
                ? toggleShowConfirmPassowordToDisable2FA
                : handleOTPSetup
            }
          >
            {user.otpEnabled ? 'Disable 2FA' : 'Setup 2FA'}
          </Button>
        )}

        {showConfirmPassowordToDisable2FA ? (
          <div className="confirm-disable-2fa">
            <form
              onSubmit={event => {
                event.preventDefault()
                const authCode =
                  event.target.elements.confirmDisable2faAuthCode.value
                handleOTPDisable(authCode)
              }}
            >
              <Field
                component={SettingsModalField}
                name="confirmDisable2faAuthCode"
                label="Authentication Code"
                placeholder="XXXXXX"
                type="text"
              />

              <div className="confirm-disable-2fa-buttons-row">
                <Button small outlined teal type="submit">
                  Disable 2FA
                </Button>
                <Button
                  small
                  text
                  onClick={toggleShowConfirmPassowordToDisable2FA}
                >
                  Cancel
                </Button>
              </div>
            </form>
          </div>
        ) : null}

        {showOtpModal && (
          <Modal onClose={closeModal} size="sm" className="settings-2fa-modal">
            <div className="settings-page-header">
              <h1>Two-Factor Authentication (2FA)</h1>
              <div className="settings-modal-close-button">
                <IconButton type="close-big" onClick={closeModal} />
              </div>
            </div>
            <div className="settings-2fa-page-content">
              <p className="settings-2fa-main-subtitles">
                Configure Google Authenticator or Authy
              </p>
              <p className="settings-2fa-main-text">
                1. Install Google Authenticator (IOS-Android) or Authy
                (IOS-Android).
              </p>
              <p className="settings-2fa-main-text">
                2. In the authenticator app, select '+' icon.
              </p>
              <p className="settings-2fa-main-text">
                3. Select "Scan a barcode (or QR code)" and use the phone's
                camera to scan this QR code.
              </p>

              <p className="settings-2fa-main-subtitles">Scan QR Code</p>

              <div className="settings-2fa-qrcode">
                <QRCode value={otpAuthUrl || ''} size={200} />
              </div>

              <p className="settings-2fa-main-subtitles">
                Or Enter Code Into Your App
              </p>
              <p className="settings-2fa-main-text">
                Secret Key: <b>{otpSecret}</b>
              </p>

              <div className="settings-2fa-form-fields">
                <TwoFactorAuthenticationForm
                  onSuccess={() => {
                    closeModal()
                    handleOTPVerify()
                  }}
                />
              </div>
            </div>
          </Modal>
        )}
      </div>
    </>
  )
}

export default reduxForm({ form: 'twoFactorAuthentication' })(
  TwoFactorAuthentication
)
